module.exports = __webpack_public_path__ + "static/media/fire-vector.792b817f.svg";